import { useEffect, useRef } from 'react'

import { Box, FloraButton, Flex, FloraTypography } from '@grupoboticario/flora-react'

import RichTextEditor from '@/components/RichTextEditor'
import { sanitizeHtmlToSafeHtml } from '@/utils/htmlHelpers/htmlHelpers'
import { generateSecureId } from '@/utils/idGenerator/idGenerator'

import * as S from './EventRegulations.styles'
import FAQItem from './FAQItem'

const FAQ_LIMITS = {
  QUESTION: 200,
  ANSWER: 500
}

const EventRegulations = ({ values, setFieldValue, isReadOnly = false }) => {
  const regulationsRef = useRef(null)

  useEffect(() => {
    if (regulationsRef.current && values.regulations) {
      regulationsRef.current.innerHTML = sanitizeHtmlToSafeHtml(values.regulations)
    }
  }, [values.regulations])

  const updateRegulationsContent = () => {
    const content = sanitizeHtmlToSafeHtml(regulationsRef.current?.innerHTML ?? '')
    setFieldValue('regulations', content)
  }

  const handleRegulationsBlur = () => {
    updateRegulationsContent()
  }

  const addFAQItem = () => {
    const currentItems = Array.isArray(values.faq) ? values.faq : []
    const newItem = {
      id: generateSecureId('faq'),
      question: '',
      answer: ''
    }
    setFieldValue('faq', [...currentItems, newItem])
  }

  const updateFAQItem = (index, field, value) => {
    const currentItems = Array.isArray(values.faq) ? values.faq : []
    const updatedItems = currentItems.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    setFieldValue('faq', updatedItems)
  }

  const deleteFAQItem = (index) => {
    const currentItems = Array.isArray(values.faq) ? values.faq : []
    const newFaq = currentItems.filter((_, i) => i !== index)
    setFieldValue('faq', newFaq)
  }

  const faqItems = Array.isArray(values.faq) ? values.faq : []
  const canDeleteFAQ = faqItems.length > 1

  return (
    <Box as="fieldset" css={S.fieldsetCss} disabled={isReadOnly}>
      <FloraTypography css={S.sectionTitleCss} fontSize="bodyLargeStandard" fontWeight="medium">
        Regulamento
      </FloraTypography>

      <RichTextEditor
        customStyles={{
          maxWidth: '920px',
          maxHeight: '300px'
        }}
        editorRef={regulationsRef}
        isReadOnly={isReadOnly}
        maxHeight="300px"
        maxWidth="920px"
        minHeight="120px"
        onBlur={handleRegulationsBlur}
        placeholder="Como será exibido no site"
      />

      <FloraTypography css={S.faqTitleCss} fontSize="bodyLargeStandard" fontWeight="medium">
        Perguntas frequentes
      </FloraTypography>

      {faqItems.map((item, index) => (
        <FAQItem
          answer={item.answer}
          canDelete={canDeleteFAQ}
          index={index}
          key={item.id ?? index}
          maxAnswerLength={FAQ_LIMITS.ANSWER}
          maxQuestionLength={FAQ_LIMITS.QUESTION}
          onAnswerChange={(answer) => updateFAQItem(index, 'answer', answer)}
          onDelete={() => deleteFAQItem(index)}
          onQuestionChange={(question) => updateFAQItem(index, 'question', question)}
          question={item.question}
        />
      ))}

      <Flex align="center" css={S.addButtonRowCss} justify="end">
        <FloraButton css={S.addButtonCss} onClick={addFAQItem} size="small" type="button" hierarchy="secondary">
          + Adicionar pergunta
        </FloraButton>
      </Flex>
    </Box>
  )
}

export default EventRegulations
